/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */
import React, { Fragment } from "react";
import axios from 'axios/dist/axios.min.js';
import utils from '../../utils/utils';
import "./style.less";

class PipelineCommunityShaiwu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      moduleDescText: '',
      gearsList: null
    };
  }

  componentDidMount() {
    this.getNoteList();
  }

  // 获取用户模板笔记列表
  getNoteList() {
    const { caskTemplateId } = this.props.config.templateConfig;
    axios({
      url: 'https://sh-gateway.shihuo.cn/v4/services/sh-gocommunity/x/v1/cash/note_list',
      method: "get",
      withCredentials: true,
      params: {
        id: caskTemplateId
      }
    }).then(res => {
      const { status, data } = res.data;
      if (status === 0) {
        const { desc, list } = data;
        this.setState({
          moduleDescText: desc,
          gearsList: list
        });
      }
    })
  }

  handleItemClick(item, index) {
    if (this.props.templateName === 'toufang') {
      utils.handleToufangClick({
        link: item.href,
        props: this.props,
        index
      })
      return
    }

    const options = {
      sort: index
    };

    utils.jumpToUrl(this.props.routeParams, item.href, item.href, options, item.id, this.props);
  }

  render() {
    const { baseConfig, templateConfig } = this.props.config;
    const { moduleDescText, gearsList } = this.state;
    if (!gearsList) {
      return null;
    }
    return (
      <div
        className={gearsList.length <= 0 ? 'pipeline-communityShaiwu no-data' : 'pipeline-communityShaiwu'}
        {...this.props['customAttributes']}
        style={{
          paddingTop: baseConfig.moduleMarginTop >= 0 ? `${baseConfig.moduleMarginTop}px` : 0,
          marginTop: baseConfig.moduleMarginTop < 0 ? `${baseConfig.moduleMarginTop}px` : 0
        }}
      >
        <h3 className="comps-title" style={{color: templateConfig.moduleDescTextColor}}>{moduleDescText}</h3>
        {
          gearsList && gearsList.length > 0 && gearsList.map((item, index) => {
            return (
              <div className="note-list" key={`item_${index}`}>
                <h3 className="gears-title" style={{color: templateConfig.gearsTextColor}}>{item.desc}</h3>
                <ul className="gears-ul">
                  {
                    item.list && item.list.length > 0 && item.list.map((value, key) => {
                      return (
                        <li
                          key={`shawu_${key}`}
                          className="item-shaiwu"
                          onClick={this.handleItemClick.bind(this, value, key)}
                        >
                          <img src={value.img} alt="" />
                          <p className="name">{value.desc}</p>
                        </li>
                      )
                    })
                  }
                </ul>
              </div>
            )
          })
        }
        {
          gearsList.length <= 0 && (
            <div className="no-notes">
              <img src="https://static.shihuocdn.cn/admin/files/20220330/37e491913ed9de52e67dd0e07169b4e3.png" alt="" />
              <p className="tips">暂无初审通过的笔记</p>
            </div>
          )
        }
      </div>
    );
  }

}

export { PipelineCommunityShaiwu };
export default PipelineCommunityShaiwu;



// WEBPACK FOOTER //
// ./components/pipeline-communityShaiwu/index.js